enum ContactMethods {
    Phone = 'contactMethods_phone',
    Email = 'contactMethods_email',
}

export default ContactMethods;
